module.exports = __webpack_public_path__ + "img/bottom_off.b1d83020.png";